import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the WordProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WordProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello WordProvider Provider');
  }

  getHotWords(chatroomname,date_type,word_type){
    let params = {
      chatroomname:chatroomname,
      date_type:date_type,
      word_type:word_type + 1
    };
    return this.http.hPost('/statistics/hot_word',params);
  }

  getWordRecord(chatroomname,date_type,keyword,page,pagesize){
    let params = {
      chatroomname:chatroomname,
      date_type:date_type,
      keyword:keyword,
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/statistics/hit_record',params);
  }

  getHotQuestion(chatroomname,date_type){
    let params = {
      chatroomname:chatroomname,
      date_type:date_type,
    };
    return this.http.hPost('/statistics/hot_question',params);
  }

  getEmojiData(chatroomname,date_type){
    let params = {
      chatroomname:chatroomname,
      date_type:date_type,
    };
    return this.http.hPost('/statistics/emotion',params);
  }

  addKeyword(keyword){
    return this.http.hPost('/statistics/add_keyword',{keyword:keyword});
  }
  getKeyword(){
    return this.http.hPost('/statistics/get_keyword');
  }

  getChatroomList(){
    return this.http.hPost('/group/get_group_list');
  }

  getEmojiOption(emojiIcon,data=[],total_count = 1){


    let legend = data.map(item => emojiIcon[item.emotion].name);

    return {
      legend:{
        data:legend
      },
      grid: {
        bottom: 60,
        top:40,
        right:20
      },
      tooltip : {
        trigger: 'axis',
        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
          type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        },
          formatter:function (params) {
            return "<img src='" + emojiIcon[params[0].name].img + "' style='width:27px;vertical-align: middle'> " + emojiIcon[params[0].name].name + ':' + params[0].value + '%'
          }
      },
      xAxis:{
        type:'category',
        data:data.map(item => item.emotion),
        axisLabel: {
          formatter: function (value) {
            return '{' + value + '| }\n{value|' + emojiIcon[value].name + '}';
          },
          margin: 20,
          interval:0,
          rich: {
            value: {
              lineHeight: 25,
              align: 'center'
            },
            angry: {
              height: 20,
              align: 'center',
              backgroundColor: {
                image: emojiIcon.angry.img
              }
            },
            sad: {
              height: 20,
              align: 'center',
              backgroundColor: {
                image: emojiIcon.sad.img
              }
            },
            neg: {
              height: 20,
              align: 'center',
              backgroundColor: {
                image: emojiIcon.neg.img
              }
            },
            surprised: {
              height: 20,
              align: 'center',
              backgroundColor: {
                image: emojiIcon.surprised.img
              }
            },
            happy: {
              height: 20,
              align: 'center',
              backgroundColor: {
                image: emojiIcon.happy.img
              }
            },
            like: {
              height: 20,
              align: 'center',
              backgroundColor: {
                image: emojiIcon.like.img
              }
            }
          }
        }
      },
      yAxis:{
        type: 'value',
        name:'%',
        color:'#000'
      },
      series:[
        {
          name:'情绪',
          type:'bar',
          data:data.map(item => Math.round(item.times*100/(total_count || 1)))
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/word/word.ts